const VERSION_CHECK_INTERVAL_MS = 30_000
const VERSION_RELOAD_GUARD_KEY = 'lzdj-app-version-reload'

let lastCheckedAt = 0
let checkInFlight: Promise<boolean> | null = null

export const isVersionSensitiveRoute = (path: string) => (
  path === '/account/publish' || path.startsWith('/account/edit/')
)

const fetchServerVersion = async () => {
  const response = await fetch(`/version.json?_t=${Date.now()}`, {
    cache: 'no-store',
    headers: { Accept: 'application/json' }
  })
  if (!response.ok) return ''
  const payload = await response.json() as { version?: unknown }
  return typeof payload.version === 'string' ? payload.version.trim() : ''
}

export const ensureLatestAppVersion = async (force = false): Promise<boolean> => {
  const now = Date.now()
  if (!force && now - lastCheckedAt < VERSION_CHECK_INTERVAL_MS) return true
  if (checkInFlight) return checkInFlight

  checkInFlight = (async () => {
    try {
      const serverVersion = await fetchServerVersion()
      lastCheckedAt = Date.now()
      if (!serverVersion || serverVersion === __APP_BUILD_ID__) {
        sessionStorage.removeItem(VERSION_RELOAD_GUARD_KEY)
        return true
      }

      if (sessionStorage.getItem(VERSION_RELOAD_GUARD_KEY) === serverVersion) {
        return true
      }

      sessionStorage.setItem(VERSION_RELOAD_GUARD_KEY, serverVersion)
      window.location.reload()
      return false
    } catch {
      return true
    } finally {
      checkInFlight = null
    }
  })()

  return checkInFlight
}

export const installChunkLoadRecovery = () => {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    window.location.reload()
  })
}
